class GiftWidget extends HTMLElement {
    constructor() {
      super();

    }

    connectedCallback() {
      this.giftPriceEl = document.querySelector("[js-gift-price]");
      this.monogramBtn = this.querySelector("[js-monogram-btn]");
      this.addBtns = this.querySelectorAll("[js-add-btn]");
      this.addGiftHandler = this.handleGifts.bind(this);
      this.addBtns.forEach(addBtn => addBtn.addEventListener("click", this.addGiftHandler));
      if (this.monogramBtn) {
        this.monogramBtn.addEventListener("click", this.handleMonogramming.bind(this));
      }
      this.monogramInitials = this.querySelector("[js-monogram-initials]");
      this.giftPrice = 0;
      this.panel = this.querySelector("[data-gift-panel]");
      this.panelToggle = this.querySelector("[data-gift-toggle]");
      this.panelBody = this.querySelector("[data-gift-body]");
      this.initPanelToggle();
    }

    handleGifts(event) {
      const btn = event.currentTarget;
      const action = btn.getAttribute("data-action");

      if (btn?.dataset?.requiresDrawer === "true" && !btn.classList.contains("is-remove")) {
        if (action === "wrist-strap") {
          event.preventDefault();
          event.stopImmediatePropagation();
          document.dispatchEvent(
            new CustomEvent("wrist-strap:open", {
              detail: {
                button: btn,
              },
            }),
          );
          return;
        } else if (action === "gift-box") {
          event.preventDefault();
          event.stopImmediatePropagation();
          document.dispatchEvent(
            new CustomEvent("gift-box:open", {
              detail: {
                button: btn,
              },
            }),
          );
          return;
        } else if (action === "gift-note") {
          event.preventDefault();
          event.stopImmediatePropagation();
          document.dispatchEvent(
            new CustomEvent("gift-note:open", {
              detail: {
                button: btn,
              },
            }),
          );
          return;
        }
      }

      this.handleBtn(btn);
      this.handleFields(btn);
      this.handlePrice();
    }

    handleBtn(btn) {
      btn.classList.toggle("is-remove");
      this.updateWristStrapTitle(btn);
      //btn.classList.contains("is-remove") ? btn.textContent = "Remove" : btn.textContent = "Add";
    }

    handleFields(btn) {
      const giftItem = btn.closest("[js-gift-product]");
      const fields = giftItem.querySelectorAll("[js-input-field]");
      const monoWristfields = document.querySelectorAll("[js-wrist-strap-field]");
      const monoGiftBoxfields = document.querySelectorAll("[js-gift-box-field ]");
      const monoGiftNotefields = document.querySelectorAll("[js-gift-note-field]");
      const pcField = giftItem.querySelector("[name='properties[_pc_pricing_ref]']");
      const bundlId = giftItem.querySelector("[name='properties[_bundle_id]']");
      const referenceTime = +new Date();
      if(btn.classList.contains("is-remove")) {
        fields?.forEach( field => field.removeAttribute("disabled"));
        pcField.value = referenceTime;
        if (bundlId) bundlId.value = String(referenceTime).slice(-4);
      }else {
        fields?.forEach( field => field.setAttribute("disabled", "disabled"));
        pcField.value = "";
        if (bundlId) bundlId.value = "";
      };

      if(btn.getAttribute("data-action") === "wrist-strap") {
        if(btn.classList.contains("is-remove")) {
          monoWristfields?.forEach( field => field.removeAttribute("disabled"));
        }else {
          monoWristfields?.forEach( field => field.setAttribute("disabled", "disabled"));
        };
      }else if(btn.getAttribute("data-action") === "gift-box") {
        if(btn.classList.contains("is-remove")) {
          monoGiftBoxfields?.forEach( field => field.removeAttribute("disabled"));
        }else {
          monoGiftBoxfields?.forEach( field => field.setAttribute("disabled", "disabled"));
        };
      }else if(btn.getAttribute("data-action") === "gift-note") {
        if(btn.classList.contains("is-remove")) {
          monoGiftNotefields?.forEach( field => field.removeAttribute("disabled"));
        }else {
          monoGiftNotefields?.forEach( field => field.setAttribute("disabled", "disabled"));
        };
      }
    }

    updateWristStrapTitle(btn) {
      if (!btn || btn.getAttribute("data-action") !== "wrist-strap") return;

      const widget = this.querySelector("[data-wrist-strap-widget]");
      if (!widget) return;

      const colorWrapper = widget.querySelector("[data-wrist-strap-color-wrapper]");
      if (!colorWrapper) return;

      if (btn.classList.contains("is-remove")) {
        colorWrapper.removeAttribute("hidden");
      } else {
        colorWrapper.setAttribute("hidden", "hidden");
      }
    }

    handlePrice() {
      if (!this.giftPriceEl) return;

      const selectedBtns = Array.from(this.querySelectorAll("[js-combo-add-btn].is-remove"));

      if (!selectedBtns.length) {
        this.giftPrice = 0;
        this.giftPriceEl.textContent = "";
        return;
      }

      const currencySymbol = this.getCurrencySymbol();

      const total = selectedBtns.reduce((sum, btn) => {
        if (this.monogramBtn && btn === this.monogramBtn) {
          return sum + this.getMonogramPrice();
        }
        const price = parseFloat(btn.getAttribute("data-price")) || 0;
        return sum + price;
      }, 0);

      this.giftPrice = total;

      if (total === 0) {
        const freeLabel = this.giftPriceEl.getAttribute("free-monogram-price") || "FREE";
        this.giftPriceEl.textContent = `+${freeLabel} in options`;
        return;
      }

      const displayPrice = Number.isInteger(total) ? total : total.toFixed(2);
      this.giftPriceEl.textContent = `+${currencySymbol}${displayPrice} in options`;
    }

    getMonogramPrice() {
      if (!this.monogramBtn) return 0;

      const datasetPrice = parseFloat(this.monogramBtn.getAttribute("data-price")) || 0;
      if (datasetPrice > 0) return datasetPrice;

      if (this.giftPriceEl?.hasAttribute("gift-discounted-price")) {
        return this.parseMoneyString(this.giftPriceEl.getAttribute("gift-discounted-price"));
      }

      if (this.giftPriceEl?.hasAttribute("free-monogram-price")) {
        return 0;
      }

      return datasetPrice;
    }

     getCurrencySymbol() {
      if (window.Shopify?.currency?.active) {
        const parts = new Intl.NumberFormat(undefined, {
          style: "currency",
          currency: window.Shopify.currency.active,
          currencyDisplay: "narrowSymbol"
        }).formatToParts(0);

        const currencyPart = parts.find(p => p.type === "currency");
        if (currencyPart?.value) return currencyPart.value;
      }

      const discounted = this.giftPriceEl?.getAttribute("gift-discounted-price");
      if (discounted) {
        const match = discounted.trim().match(/^[^\d-]+/);
        if (match?.[0]) return match[0];
      }

      return "£";
    }

    parseMoneyString(value) {
      if (!value) return 0;

      const numeric = value.replace(/[^0-9.,-]/g, "").replace(/,/g, "");
      const parsed = parseFloat(numeric);

      return Number.isNaN(parsed) ? 0 : parsed;
    }

    handleMonogramming({ currentTarget }) {
      if(currentTarget.classList.contains("is-remove")) {
        const comboWidget = currentTarget.closest("[js-gift-product]");
        if(comboWidget) {
          const fields = comboWidget.querySelectorAll("[js-monogram-combo-field]");
  
          fields.forEach(el => el.setAttribute("disabled", "disabled"));

          const placeholderInitialsLabel = this.monogramInitials?.getAttribute("data-initial-placeholder-label");
          const initialCharacter = this.monogramInitials?.getAttribute("data-initial-character");

          if(this.monogramInitials && placeholderInitialsLabel && initialCharacter) {
            this.monogramInitials.innerHTML = `${placeholderInitialsLabel} ${initialCharacter}`;
          }

          setTimeout(() => {
            currentTarget.classList.remove("is-remove");
            currentTarget.classList.remove("has-monogramming");
            this.handlePrice()
          })
        }
      }
    }

    addGiftProduct(btn) {
      if (!btn || btn.classList.contains("is-remove")) return;
      this.handleBtn(btn);
      this.handleFields(btn);
      this.handlePrice();
    }

    initPanelToggle() {
      if (!this.panel || !this.panelToggle || !this.panelBody || this.panelToggle.hasAttribute("data-gift-toggle-init")) {
        return;
      }

      this.panelToggle.setAttribute("data-gift-toggle-init", "true");
      const isCollapsed = this.panel.classList.contains("is-collapsed");
      this.panelBody.hidden = isCollapsed;
      this.panelToggle.setAttribute("aria-expanded", (!isCollapsed).toString());
      this.panelToggle.addEventListener("click", () => {
        const nowCollapsed = this.panel.classList.toggle("is-collapsed");
        this.panelToggle.setAttribute("aria-expanded", (!nowCollapsed).toString());
        this.panelBody.hidden = nowCollapsed;
      });
    }
}

customElements.define('gift-widget', GiftWidget);
